// extracted by mini-css-extract-plugin
export default {"main":"Tabs--main--y3zBo","icons":"Tabs--icons--DSU16","horizontal":"Tabs--horizontal--jTAL5","vertical":"Tabs--vertical--mle+d"};